/**
 * @generated SignedSource<<86e2491b1adcaac56ddbc8c886c7d178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateSectionChordsMutation_song$data = {
  readonly id: string;
  readonly mongoVersion: number;
  readonly " $fragmentType": "UpdateSectionChordsMutation_song";
};
export type UpdateSectionChordsMutation_song$key = {
  readonly " $data"?: UpdateSectionChordsMutation_song$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateSectionChordsMutation_song">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateSectionChordsMutation_song",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mongoVersion",
      "storageKey": null
    }
  ],
  "type": "Song",
  "abstractKey": null
};

(node as any).hash = "6855dc6b237e4375446fff1529e30e50";

export default node;
